import CategoriesList from "../../components/categories/CategoriesList"

export const SectionsPage = () => {

    return (
        <CategoriesList></CategoriesList>
    )
}